import { Stack, Typography, useTheme } from "@mui/material";
import { type FC, Fragment } from "react";
import { useGoalSummaryLine } from "web_myplann/Goals/Hooks/useGoalSummaryLine";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";

type Props = {
	goal: GoalDetail;
};

export const GoalDetailSummaryLine: FC<Props> = ({ goal }) => {
	const { palette, spacingTokens } = useTheme();
	const summary = useGoalSummaryLine(goal);

	if (!summary) return null;

	return (
		<Stack mt={spacingTokens.md} gap={spacingTokens.xs}>
			{summary.rentLabel && (
				<Typography variant="hint" tabular>
					{summary.rentLabel}
				</Typography>
			)}
			{summary.segments.length > 0 && (
				<Typography variant="caption" color={palette.grey[700]} tabular>
					{summary.segments.map((segment, index) => (
						<Fragment key={segment.label}>
							<Typography variant="hint">
								{index > 0 ? ` · ${segment.label}:` : `${segment.label}:`}
							</Typography>{" "}
							{segment.value}
							{segment.note && (
								<Typography variant="hint">{` ${segment.note}`}</Typography>
							)}
						</Fragment>
					))}
				</Typography>
			)}
		</Stack>
	);
};
